import { render, staticRenderFns } from "./AutomatedRules.vue?vue&type=template&id=e89be838&scoped=true&"
import script from "./AutomatedRules.vue?vue&type=script&lang=ts&"
export * from "./AutomatedRules.vue?vue&type=script&lang=ts&"
import style0 from "./AutomatedRules.vue?vue&type=style&index=0&id=e89be838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89be838",
  null
  
)

export default component.exports